module.exports = __webpack_public_path__ + "static/media/namgel-lama.6c77dd85.jpg";